import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const Information = () => {
  return (
    <Box paddingTop="s24" paddingLeft="s24" paddingRight="s40">
      <Box
        background="champagne200"
        paddingX="s24"
        paddingY="s16"
        borderRadius={{
          all: 'abs008',
        }}
        gap="s16"
      >
        <Text.Header2>
          {i18n.t('payroll_integrations.incidences.datev_lauds.sync.information.title')}
        </Text.Header2>
        <Text.Normal>
          {i18n.t('payroll_integrations.incidences.datev_lauds.sync.information.message')}
        </Text.Normal>
      </Box>
    </Box>
  )
}

export default Information
